// @flow
'use strict';

import * as React from 'react';

import type { ItemProps } from '../types';
import { tipoDocumento } from './abas_informacoes';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';
import TableDetalhes from '../../../common/detalhes_documento/table_detalhes';
import DocumentosFiscaisReferenciados from './documentos_fiscais_referenciados';

export default function Nfe({ item } : ItemProps) {
  return (
      <div className="tab-pane active">
        <h3>Dados da NF-e</h3>
        <RowDetalhes data={ item }>
          <ColumnDetalhes field="numero" width="15%">Número</ColumnDetalhes>
          <ColumnDetalhes field="serie" width="15%">Série</ColumnDetalhes>
          <ColumnDetalhes field="modeloId" type="modelo" width="20%">Modelo</ColumnDetalhes>
          <ColumnDetalhes field="emitidoEm" type="dataHora" width="30%">Data de Emissão</ColumnDetalhes>
          <ColumnDetalhes field="valor" type="moeda" width="20%">Valor Total</ColumnDetalhes>
        </RowDetalhes>

        <h3>Emitente</h3>
        <RowDetalhes data={ item.emitente }>
          <ColumnDetalhes field="cnpj" type="documento" width="25%">{ tipoDocumento(item.emitente) }</ColumnDetalhes>
          <ColumnDetalhes field="nome">Nome / Razão Social</ColumnDetalhes>
          <ColumnDetalhes field="inscricaoEstadual" width="18%">IE</ColumnDetalhes>
          <ColumnDetalhes field="uf" width="5%">UF</ColumnDetalhes>
        </RowDetalhes>

        <h3>Destinatário</h3>
        <RowDetalhes data={ item.destinatario }>
          <ColumnDetalhes field="cnpj" type="documento" width="25%">{ tipoDocumento(item.destinatario) }</ColumnDetalhes>
          <ColumnDetalhes field="nome">Nome / Razão Social</ColumnDetalhes>
          <ColumnDetalhes field="inscricaoEstadual" width="18%">IE</ColumnDetalhes>
          <ColumnDetalhes field="uf" width="5%">UF</ColumnDetalhes>
        </RowDetalhes>

        <h3>Emissão</h3>
        <RowDetalhes data={ item.emissao } className="no-margin-bottom">
          <ColumnDetalhes field="munFatoGeradorIcms" width="30%">Município F. Gerador ICMS</ColumnDetalhes>
          <ColumnDetalhes field="munFatoGeradorIbsCbs" width="30%">Município F. Gerador IBS/CBS</ColumnDetalhes>
          <ColumnDetalhes field="tipoOperacao" width="20%">Tipo de Operação</ColumnDetalhes>
          <ColumnDetalhes field="destinoOperacao" width="20%">Destino da Operação</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ item.emissao } className="no-margin-bottom">
          <ColumnDetalhes field="tipoEmissao" width="25%">Tipo de Emissão</ColumnDetalhes>
          <ColumnDetalhes field="finalidade" width="25%">Finalidade</ColumnDetalhes>
          <ColumnDetalhes field="tipoNotaDebito" width="25%">Tipo Nota de Débito</ColumnDetalhes>
          <ColumnDetalhes field="tipoNotaCredito" width="25%">Tipo Nota de Crédito</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ item.emissao } className="no-margin-bottom">
          <ColumnDetalhes field="naturezaOperacao">Natureza da Operação</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ item.emissao } className="no-margin-bottom">
          <ColumnDetalhes field="consumidorFinal" width="33%">Consumidor Final</ColumnDetalhes>
          <ColumnDetalhes field="presencaComprador" width="40%">Presença Comprador</ColumnDetalhes>
          <ColumnDetalhes field="" width="27%"/>
        </RowDetalhes>
        <RowDetalhes data={ item.emissao } className="no-margin-bottom">
          <ColumnDetalhes field="intermedMarket" width="30%">Intermediador</ColumnDetalhes>
          <ColumnDetalhes field="cnpjIntermed" type="documento" width="20%">CNPJ Intermediador</ColumnDetalhes>
          <ColumnDetalhes field="idIntermed" width="50%">Identificador do Intermediador</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ item.emissao }>
          <ColumnDetalhes field="processoEmissao" width="25%">Processo de Emissão</ColumnDetalhes>
          <ColumnDetalhes field="versaoProcesso" width="25%">Versão do Processo</ColumnDetalhes>
          <ColumnDetalhes field="digestValue" width="50%" colSpan={ 2 }><i>Digest Value</i> da NF-e</ColumnDetalhes>
        </RowDetalhes>

        <h3>Eventos</h3>
        <TableDetalhes data={ item.eventos } noDataClass="padding-10" noDataMsg="Nenhum evento para a empresa.">
          <ColumnDetalhes field="data">Data</ColumnDetalhes>
          <ColumnDetalhes field="tipo">Tipo</ColumnDetalhes>
          <ColumnDetalhes field="protocolo">Protocolo</ColumnDetalhes>
        </TableDetalhes>

         <DocumentosFiscaisReferenciados docFiscaisReferenciados={ item.docFiscaisReferenciados }/>
      </div>
  );
}
